(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_efs-media-slide"] && !Shopify.designMode) return;
  try {
    const MOBILE_BREAKPOINT = 749;
  const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;
  const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const lazyObserver = new IntersectionObserver((entries, obs) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.preload = 'metadata';
        obs.unobserve(entry.target);
      }
    }
  }, { rootMargin: '200px' });

  const mobileObserver = prefersReducedMotion ? null : new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!isMobile()) continue;
      if (entry.isIntersecting) entry.target.play().catch(() => {});
      else entry.target.pause();
    }
  }, { threshold: 0.5 });

  const initSlide = (slide) => {
    if (slide.dataset.initialized) return;
    slide.dataset.initialized = 'true';
    const video = slide.querySelector('video');
    if (!video) return;

    if (video.preload === 'none') lazyObserver.observe(video);
    if (prefersReducedMotion) return;

    if (video.dataset.playOnHover === 'true') {
      slide.addEventListener('mouseenter', () => {
        if (!isMobile()) video.play().catch(() => {});
      });
      slide.addEventListener('mouseleave', () => {
        if (!isMobile()) { video.pause(); video.currentTime = 0; }
      });
    }

    /* Mobile autoplay: only when slide is NOT inside an efs-media-slider
       (sliders control active-slide playback themselves). */
    const insideSlider = slide.closest('.efs-media-slider');
    if (!insideSlider && video.dataset.autoplayMobile === 'true' && mobileObserver) {
      mobileObserver.observe(video);
    }
  };

  const initIn = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    for (const slide of scope.querySelectorAll('.efs-media-slide')) initSlide(slide);
    if (root && root.classList && root.classList.contains('efs-media-slide')) initSlide(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initIn(document));
  } else {
    initIn(document);
  }
  document.addEventListener('shopify:section:load', (e) => initIn(e.target));
  document.addEventListener('shopify:block:select', (e) => initIn(e.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["efs-countdown-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.container = this.querySelector('.countdown-container');
          // Wir parsen das Datum. Falls es ungültig ist, brechen wir ab.
          this.targetDate = new Date(this.container.dataset.date).getTime();
          this.expiredMsg = this.querySelector('.countdown-expired');

          if (isNaN(this.targetDate)) {
            console.error('Countdown: Ungültiges Datumsformat');
            return;
          }

          this.elements = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };

          this.updateTimer();
          this.interval = setInterval(() => this.updateTimer(), 1000);

          this.container.style.opacity = '1';
        }

        updateTimer() {
          const now = new Date().getTime();
          const distance = this.targetDate - now;

          if (distance < 0) {
            clearInterval(this.interval);
            this.container.style.display = 'none';
            if (this.expiredMsg) this.expiredMsg.style.display = 'block';
            return;
          }

          const d = Math.floor(distance / (1000 * 60 * 60 * 24));
          const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const s = Math.floor((distance % (1000 * 60)) / 1000);

          this.elements.days.innerText = d.toString().padStart(2, '0');
          this.elements.hours.innerText = h.toString().padStart(2, '0');
          this.elements.minutes.innerText = m.toString().padStart(2, '0');
          this.elements.seconds.innerText = s.toString().padStart(2, '0');
        }

        disconnectedCallback() {
          if (this.interval) clearInterval(this.interval);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["efs-hero-card-slider"] && !Shopify.designMode) return;
  try {
    const MOBILE_BREAKPOINT = 749;
  const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroCardSlider(slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    const track = slider.querySelector('.efs-hero-card-slider__track');
    if (!track) return;

    const prevBtn = slider.querySelector('.efs-hero-card-slider__arrow--prev');
    const nextBtn = slider.querySelector('.efs-hero-card-slider__arrow--next');
    const dotsContainer = slider.querySelector('.efs-hero-card-slider__dots');

    let slides = [];
    let offsets = [];
    let paddingStart = 0;
    let activeIndex = 0;
    let rafId = 0;

    const refreshGeometry = () => {
      slides = Array.from(track.querySelectorAll(':scope > .shopify-block'));
      paddingStart = slides[0] ? slides[0].offsetLeft : 0;
      offsets = slides.map((s) => s.offsetLeft - paddingStart);
    };

    const closestIndex = () => {
      if (!slides.length) return 0;
      const left = track.scrollLeft;
      let best = 0;
      let min = Infinity;
      for (let i = 0; i < offsets.length; i++) {
        const d = Math.abs(offsets[i] - left);
        if (d < min) {
          min = d;
          best = i;
        }
      }
      return best;
    };

    const scrollToIndex = (i, smooth = true) => {
      const target = offsets[i];
      if (target === undefined) return;
      track.scrollTo({
        left: target,
        behavior: smooth && !prefersReducedMotion ? 'smooth' : 'instant',
      });
    };

    const buildDots = () => {
      if (!dotsContainer) return;
      dotsContainer.textContent = '';
      if (slides.length <= 1) {
        dotsContainer.hidden = true;
        return;
      }
      dotsContainer.hidden = false;
      for (let i = 0; i < slides.length; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'efs-hero-card-slider__dot';
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => scrollToIndex(i));
        dotsContainer.appendChild(dot);
      }
    };

    const updateUi = () => {
      rafId = 0;
      if (prevBtn) prevBtn.hidden = track.scrollLeft <= 1;
      if (nextBtn) {
        nextBtn.hidden =
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }
      const idx = closestIndex();
      if (idx !== activeIndex) {
        activeIndex = idx;
        if (dotsContainer) {
          const dots = dotsContainer.children;
          for (let i = 0; i < dots.length; i++) {
            if (i === idx) dots[i].setAttribute('aria-current', 'true');
            else dots[i].removeAttribute('aria-current');
          }
        }
      }
      updateParallax();
    };

    const scheduleUi = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(updateUi);
    };

    /* --- Parallax --- */
    const parallaxEnabled =
      slider.dataset.parallax === 'true' && !prefersReducedMotion;
    const parallaxAmount =
      parseFloat(
        getComputedStyle(slider).getPropertyValue('--hcs-parallax-amount')
      ) || 0;

    const updateParallax = () => {
      if (!parallaxEnabled || parallaxAmount === 0) return;
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      for (const card of slides) {
        const img = card.querySelector('.efs-hero-card__image');
        if (!img) continue;
        const r = card.getBoundingClientRect();
        const cardCenter = r.left + r.width / 2;
        const delta = (cardCenter - center) / r.width;
        const clamped = Math.max(-1.5, Math.min(1.5, delta));
        const tx = -clamped * parallaxAmount;
        img.style.setProperty('--hc-parallax', `${tx}%`);
      }
    };

    refreshGeometry();
    buildDots();
    updateUi();

    track.addEventListener('scroll', scheduleUi, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', () =>
        scrollToIndex(Math.max(0, closestIndex() - 1))
      );
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () =>
        scrollToIndex(Math.min(slides.length - 1, closestIndex() + 1))
      );
    }

    const ro = new ResizeObserver(() => {
      const keep = activeIndex;
      refreshGeometry();
      scrollToIndex(Math.min(keep, slides.length - 1), false);
      scheduleUi();
    });
    ro.observe(track);

    /* --- Keyboard --- */
    track.tabIndex = 0;
    track.addEventListener('keydown', (e) => {
      const i = closestIndex();
      let target = null;
      if (e.key === 'ArrowLeft') target = Math.max(0, i - 1);
      else if (e.key === 'ArrowRight') target = Math.min(slides.length - 1, i + 1);
      else if (e.key === 'Home') target = 0;
      else if (e.key === 'End') target = slides.length - 1;
      if (target !== null) {
        e.preventDefault();
        scrollToIndex(target);
      }
    });

    /* --- Mouse-only drag-to-scroll --- */
    let startX = 0;
    let scrollStart = 0;
    let dragging = false;
    let moved = false;
    let slideStride = 0;

    const refreshStride = () => {
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.gap) || 0;
      slideStride = slides[0] ? slides[0].offsetWidth + gap : track.clientWidth;
    };
    refreshStride();

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      dragging = true;
      moved = false;
      track.style.scrollSnapType = 'none';
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const delta = startX - e.clientX;
      if (!moved && Math.abs(delta) > 8) {
        moved = true;
        slider.setAttribute('dragging', '');
      }
      if (moved) track.scrollLeft = scrollStart + delta;
    });

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      slider.removeAttribute('dragging');
      if (!moved) {
        track.style.scrollSnapType = '';
        scheduleUi();
        return;
      }
      const dragDelta = track.scrollLeft - scrollStart;
      const dir = Math.sign(dragDelta);
      const idx = closestIndex();
      const movedEnough = Math.abs(dragDelta % slideStride) > slideStride * 0.3;
      const target = movedEnough
        ? Math.max(0, Math.min(slides.length - 1, idx + dir))
        : idx;
      track.scrollTo({ left: offsets[target] || 0, behavior: 'smooth' });
      const onEnd = () => {
        track.style.scrollSnapType = '';
        track.removeEventListener('scrollend', onEnd);
        scheduleUi();
      };
      track.addEventListener('scrollend', onEnd);
      setTimeout(onEnd, 500);
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    /* --- Stride refresh on resize --- */
    const strideRo = new ResizeObserver(refreshStride);
    strideRo.observe(track);
  }

  const initIn = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    for (const slider of scope.querySelectorAll('.efs-hero-card-slider')) {
      initHeroCardSlider(slider);
    }
    if (root && root.classList && root.classList.contains('efs-hero-card-slider')) {
      initHeroCardSlider(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initIn(document));
  } else {
    initIn(document);
  }
  document.addEventListener('shopify:section:load', (e) => initIn(e.target));
  document.addEventListener('shopify:block:select', (e) => initIn(e.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["efs-media-slider"] && !Shopify.designMode) return;
  try {
    const MOBILE_BREAKPOINT = 749;
  const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMediaSlider(slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    const track = slider.querySelector('.efs-media-slider__track');
    const prevBtn = slider.querySelector('.efs-media-slider__arrow--prev');
    const nextBtn = slider.querySelector('.efs-media-slider__arrow--next');
    const dotsContainer = slider.querySelector('.efs-media-slider__dots');

    /* --- Geometry cache (invalidated on resize) --- */
    let slides = [];
    let offsets = [];
    let slideStride = 0;
    let paddingStart = 0;

    const refreshGeometry = () => {
      slides = Array.from(track.querySelectorAll(':scope > .shopify-block'));
      const cs = getComputedStyle(track);
      paddingStart = parseFloat(cs.paddingInlineStart) || 0;
      const gap = parseFloat(cs.gap) || 0;
      offsets = slides.map((s) => s.offsetLeft - paddingStart);
      slideStride = slides[0] ? slides[0].offsetWidth + gap : track.clientWidth;
    };

    const closestIndex = () => {
      if (!slides.length) return 0;
      const left = track.scrollLeft;
      let best = 0;
      let min = Infinity;
      for (let i = 0; i < offsets.length; i++) {
        const d = Math.abs(offsets[i] - left);
        if (d < min) { min = d; best = i; }
      }
      return best;
    };

    const scrollToIndex = (i, smooth = true) => {
      if (!offsets[i] && i !== 0) return;
      track.scrollTo({ left: offsets[i] || 0, behavior: smooth && !prefersReducedMotion ? 'smooth' : 'instant' });
    };

    /* --- Dots (only when >1 slide) --- */
    const buildDots = () => {
      if (!dotsContainer) return;
      dotsContainer.textContent = '';
      if (slides.length <= 1) { dotsContainer.hidden = true; return; }
      dotsContainer.hidden = false;
      for (let i = 0; i < slides.length; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'efs-media-slider__dot';
        const labelTemplate = dotsContainer.dataset.dotLabel || '[index] / [length]';
        dot.setAttribute('aria-label', labelTemplate.replace('[index]', `${i + 1}`).replace('[length]', `${slides.length}`));
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => scrollToIndex(i));
        dotsContainer.appendChild(dot);
      }
    };

    /* --- Arrow + dot state --- */
    let rafId = 0;
    let isDragging = false;
    let activeIndex = 0;

    const updateUi = () => {
      rafId = 0;
      if (prevBtn) prevBtn.hidden = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      const idx = closestIndex();
      if (idx !== activeIndex) {
        activeIndex = idx;
        if (dotsContainer) {
          const dots = dotsContainer.children;
          for (let i = 0; i < dots.length; i++) {
            if (i === idx) dots[i].setAttribute('aria-current', 'true');
            else dots[i].removeAttribute('aria-current');
          }
        }
        onActiveSlideChange(idx);
      }
    };

    const scheduleUi = () => {
      if (isDragging || rafId) return;
      rafId = requestAnimationFrame(updateUi);
    };

    /* --- Video autoplay: only active slide on mobile --- */
    const videos = () => slides.map((s) => s.querySelector('video'));
    const onActiveSlideChange = (idx) => {
      if (prefersReducedMotion) return;
      if (window.innerWidth > MOBILE_BREAKPOINT) return;
      const vids = videos();
      for (let i = 0; i < vids.length; i++) {
        const v = vids[i];
        if (!v) continue;
        if (v.dataset.autoplayMobile !== 'true') continue;
        if (i === idx) { v.play().catch(() => {}); } else { v.pause(); }
      }
    };

    /* --- Init --- */
    refreshGeometry();
    buildDots();
    updateUi();

    track.addEventListener('scroll', scheduleUi, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(Math.max(0, closestIndex() - 1)));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(Math.min(slides.length - 1, closestIndex() + 1)));

    /* --- Keyboard --- */
    track.tabIndex = 0;
    track.addEventListener('keydown', (e) => {
      const i = closestIndex();
      let target = null;
      if (e.key === 'ArrowLeft') target = Math.max(0, i - 1);
      else if (e.key === 'ArrowRight') target = Math.min(slides.length - 1, i + 1);
      else if (e.key === 'Home') target = 0;
      else if (e.key === 'End') target = slides.length - 1;
      if (target !== null) { e.preventDefault(); scrollToIndex(target); }
    });

    /* --- Resize: invalidate cache, re-align active --- */
    const ro = new ResizeObserver(() => {
      const keepIdx = activeIndex;
      refreshGeometry();
      scrollToIndex(Math.min(keepIdx, slides.length - 1), false);
      scheduleUi();
    });
    ro.observe(track);

    /* --- Mouse-only drag-to-scroll --- */
    let startX = 0;
    let scrollStart = 0;
    let dragging = false;
    let moved = false;

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      dragging = true;
      isDragging = true;
      moved = false;
      track.style.scrollSnapType = 'none';
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const delta = startX - e.clientX;
      if (!moved && Math.abs(delta) > 3) {
        moved = true;
        slider.setAttribute('dragging', '');
      }
      if (moved) track.scrollLeft = scrollStart + delta;
    });

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      isDragging = false;
      slider.removeAttribute('dragging');
      if (!moved) {
        track.style.scrollSnapType = '';
        scheduleUi();
        return;
      }
      const dragDelta = track.scrollLeft - scrollStart;
      const dir = Math.sign(dragDelta);
      const idx = closestIndex();
      const movedEnough = Math.abs(dragDelta % slideStride) > slideStride * 0.3;
      const target = movedEnough ? Math.max(0, Math.min(slides.length - 1, idx + dir)) : idx;
      track.scrollTo({ left: offsets[target] || 0, behavior: 'smooth' });
      const onEnd = () => {
        track.style.scrollSnapType = '';
        track.removeEventListener('scrollend', onEnd);
        scheduleUi();
      };
      track.addEventListener('scrollend', onEnd);
      setTimeout(onEnd, 500);
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  const initIn = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    for (const slider of scope.querySelectorAll('.efs-media-slider')) initMediaSlider(slider);
    if (root && root.classList && root.classList.contains('efs-media-slider')) initMediaSlider(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initIn(document));
  } else {
    initIn(document);
  }
  document.addEventListener('shopify:section:load', (e) => initIn(e.target));
  document.addEventListener('shopify:block:select', (e) => initIn(e.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["efs-usp-list"] && !Shopify.designMode) return;
  try {
    const lists = document.querySelectorAll('.efs-usp-list__items[data-entrance]');
  for (const list of lists) {
    const effect = list.dataset.entrance;
    if (!effect || effect === 'none') continue;
    const repeat = list.dataset.entranceRepeat === 'true';
    const items = list.querySelectorAll('.efs-usp-list-item');

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('efs-usp-list-item--visible');
            if (!repeat) observer.unobserve(entry.target);
          } else if (repeat) {
            entry.target.classList.remove('efs-usp-list-item--visible');
          }
        }
      },
      { threshold: 0.1 }
    );

    for (const item of items) {
      observer.observe(item);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
